module.exports = __webpack_public_path__ + "static/media/EntItem_elAppleQRcode_928135.9889adfc.jpg";